import { render, staticRenderFns } from "./ModalImportacaoBeneficiarioForm.vue?vue&type=template&id=6b8da44b&scoped=true"
import script from "./ModalImportacaoBeneficiarioForm.vue?vue&type=script&lang=js"
export * from "./ModalImportacaoBeneficiarioForm.vue?vue&type=script&lang=js"
import style0 from "./ModalImportacaoBeneficiarioForm.vue?vue&type=style&index=0&id=6b8da44b&prod&scoped=true&lang=css"
import style1 from "./ModalImportacaoBeneficiarioForm.vue?vue&type=style&index=1&id=6b8da44b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8da44b",
  null
  
)

export default component.exports